/**
 * Created by rathompson on 9/28/21
 * File: IdentityAddressRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body, Tooltip } from '@panwds/react-ui'
import { useMemo } from 'react'
import {
  LABEL_IDP_DISABLED,
  LABEL_IDP_DISABLED_MULTIPLE,
  LABEL_INHERITED_DISABLED,
  LABEL_ONLY_DISABLED,
} from '../../../../constants/LabelConstants'
import StringTemplate from '../../../../../common/utils/StringTemplate'

/**
 *   Identity email address table cell
 */
const IdentityAddressRenderer = ({ row, value }) => {
  const mouseover = useMemo(() => {
    if (row.original?.isOnlyMember) return LABEL_ONLY_DISABLED
    if (row.original?.isInheritedMember) return LABEL_INHERITED_DISABLED
    if (row.original?.isIDPMember) {
      if (row.original?.sources.size === 1) {
        return StringTemplate(LABEL_IDP_DISABLED, [row.original?.sources.values().next().value])
      }
      return LABEL_IDP_DISABLED_MULTIPLE
    }
    return ''
  }, [row])

  const mouseoverEnabled = useMemo(() => {
    return row.original.isOnlyMember || row.original.isInheritedMember || row.original.isIDPMember
  }, [row])
  return (
    <div className='tw-flex tw-w-full tw-h-full tw-p-1 tw-truncate'>
      {mouseoverEnabled &&
      <Tooltip label={mouseover}>
        <Body size="lg" addClassName='tw-truncate'>{value}</Body>
      </Tooltip>}
      {!mouseoverEnabled && <Body size="lg" addClassName='tw-truncate'>{value}</Body>}
    </div>
  )
}

IdentityAddressRenderer.propTypes = {}
export default IdentityAddressRenderer
